// extracted by mini-css-extract-plugin
export default {"button":"Button_button__3iaQG","red":"Button_red__TX9TY","green":"Button_green__Mu9ED","disabled":"Button_disabled__YbRJP"};